import type { IAdvertiser, IParsedAdvertiser } from '@/Interfaces/Advertiser.interface';
import type { ICampaignManagementAdvertiserControlOption, IControlOption } from '@/Interfaces/ControlOption.interface';

// Shared shape for the per-context advertiser → control-option mappers below.
// Each consumer (filters, parsed lists, campaign-management dropdowns) needs a
// different IControlOption variant; the generic lets us reuse the input type
// (IAdvertiser) without restating it on every mapper.
export type AdvertiserMapper<T extends IControlOption = IControlOption> = (advertiser: IAdvertiser) => T;

export const parsedAdvertisersMapper: AdvertiserMapper<IParsedAdvertiser> = ({
  hasDv360Partner,
  neuronAdvertiser,
  name,
  id,
  adswizzAdvertiser,
  beeswaxAdvertiser,
  hasEsmSemAccount,
  hasEsmSclAccount,
  hasSimplifiAccount,
  hasGamAdvertiser,
}) => ({
  beeswaxId: beeswaxAdvertiser?.beeswax_id,
  neuronId: neuronAdvertiser?.id,
  hasDv360Partner,
  label: name,
  value: id,
  adswizzId: adswizzAdvertiser?.id,
  ribeyeAdvertiserId: id,
  hasEsmSemAccount,
  hasEsmSclAccount,
  hasSimplifiAccount,
  hasGamAdvertiser,
});

export const ribeyeAdvertiserMapper: AdvertiserMapper<IControlOption> = ({ id, name }) => ({
  value: id,
  label: name,
});

export const campaignManagementAdvertiserMapper: AdvertiserMapper<ICampaignManagementAdvertiserControlOption> = ({
  id,
  name,
  beeswaxAdvertiser,
}) => ({
  value: id,
  label: name,
  beeswaxId: beeswaxAdvertiser?.beeswax_id,
});
